export interface Violation {
  message?: string;
  messageTemplate?: string;
  parameters?: Record<string, unknown>;
  propertyPath?: string;
  invalidValue?: string;
  code?: string;
}

export interface ApiProblem {
  type?: string;
  title?: string;
  detail?: string;
}

export interface ValidationApiProblem extends ApiProblem {
  violations: (Violation | null)[];
}

export const isValidationApiProblem = (body: unknown): body is ValidationApiProblem =>
  typeof body === 'object' &&
  body !== null &&
  Array.isArray((body as Partial<ValidationApiProblem>).violations);

export const getValidationApiProblem = (error: unknown): ValidationApiProblem | undefined => {
  if (isValidationApiProblem(error)) {
    return error;
  }

  const body = (error as { error?: unknown } | null | undefined)?.error;
  return isValidationApiProblem(body) ? body : undefined;
};
